import Store from "../Store";
import { actions, mutations, apis, getters } from "../constants";
import { util } from "../../utils";

let eventIdAndGroupIdMap = {};

export default function(ajax) {
  let store = new Store({
    state: {
      currentUser: null,
      currentApp: null,
      userProps: [],
      eventEnvs: [],
      eventGroups: [],
      eventList: [],
      eventIdMap: {},
      eventNameMap: {},
      groupIdMap: {},
      iconMap: (() => {
        let map = {
          // 环境属性
          browser_brand: "internet",
          browser_version: "internet",
          website: "web",
          referer_url: "web",
          current_url: "web",
          country: "region",
          area: "region",
          city: "region",
          os: "platform",
          ov: "platform",
          resolution_h: "platform",
          resolution_l: "platform",
          first_referer_url: "web",
          ip: "web",
          utm_source: "utm",
          utm_medium: "utm",
          utm_campaign: "utm",
          utm_content: "utm",
          utm_term: "utm",
          version: "overall",
          channel: "overall",
          network: "platform",
          mccmnc: "platform",
          device_brand: "overall",
          device_model: "overall",
          event_duration: "time",
          // 用户属性
          first_visit_time: "time",
          last_visit_time: "time",
          visit_times: "time",
          duration: "time",
          name: "personal",
          app_user_id: "personal",
          zg_id: "personal",
          is_anonymous: "type",
          current_country: "region",
          current_area: "region",
          current_city: "region",
          current_app_version: "overall",
          current_app_channel: "overall",
          first_version: "overall",
          first_channel: "overall",
          current_device_brand: "overall",
          current_device_model: "overall",
          current_mccmnc: "platform",
          user_referer_url: "web",
          first_website: "web",
          first_utm_source: "utm",
          first_utm_medium: "utm",
          first_utm_campaign: "utm",
          first_utm_content: "utm",
          first_utm_term: "utm",
          current_browser_brand: "internet",
          current_browser_version: "internet",
          current_os: "platform",
          current_ov: "platform",
          current_resolution_h: "platform",
          current_resolution_l: "platform"
        };
        for (let prop in map) {
          map[prop] = "icon-" + map[prop];
        }
        return map;
      })()
    },
    getters: {
      [getters.sys.getUserDimensionProps](state) {
        let list = [];
        // let blockArr = ['用户价值', '流失风险', '诸葛标签'] // 接口已过滤
        let fixedProp = state.userProps.filter(prop => {
          return prop.category === "fixed";
        });
        let customProp = state.userProps.filter(prop => {
          return prop.category !== "fixed";
        });
        fixedProp.forEach((item, i) => {
          if (item.name !== "current_city") {
            list.push(item);
          }
          if (item.name === "current_city") {
            list.push(item);
            list = list.concat(customProp);
          }
        });
        return list;
      }
    },
    mutations: {
      [mutations.biz.sys.edit](state, callback = () => {}) {
        callback(state);
      },
      [mutations.biz.sys.setCurrentUser](state, user) {
        state.currentUser = user;
      },
      [mutations.biz.sys.setUserProps](state, list) {
        // todo 对属性列表进行标准化处理，同触发环境、事件属性等一同标准化，后期可在服务器端统一标准化
        list.forEach(prop => {
          prop.label = prop.alias_name || prop.text;
          prop.value = prop.name;
          prop.icon = state.iconMap[prop.name] || "icon-custom";
          prop.isUserProp = true;
          prop.custom = prop.category === "custom";
          // 内置属性（名称、类型、诸葛ID 、用户ID）： 实时
          if (
            prop.name === "name" ||
            prop.name === "is_anonymous" ||
            prop.name === "zg_id" ||
            prop.name === "app_user_id"
          ) {
            prop.realTime = true;
          } else {
            prop.realTime = false;
          }
          prop.dimensionId = [prop.dimension_sub, prop.value].join(","); // 增加属性细分唯一字段，区分同名自定义属性
        });
        if (sessionStorage.getItem("urlAppId")) {
          sessionStorage.setItem("userPropsTemp", JSON.stringify(list));
        }else{
          state.userProps = list;
        }
      },
      [mutations.biz.sys.setEventGroups](state, groups) {
        let eventList = [];
        let idMap = {};
        let nameMap = {};
        let validGroups = [];
        let groupIdMap = {};
        let eventAttrMap = {};
        let initEventIdAndGroupIdMap = {};
        groups.forEach(group => {
          groupIdMap[group.groupId] = group;
          initEventIdAndGroupIdMap[group.groupId] = {};
          if (group.groupId > -1) {
            validGroups.push(group);
          } else {
            group.groupName = "未分组";
          }
          group.eventList.forEach(event => {
            eventAttrMap[event.event_id] = [];
            initEventIdAndGroupIdMap[group.groupId][event.event_id] = true;
            // todo 对事件的属性做遍历，同触发环境、用户属性等一同标准化，后期可在服务器端统一标准化
            event.event_attrs.forEach(prop => {
              prop.id = prop.attr_id;
              prop.label = prop.alias_name || prop.attr_name;
              prop.value = prop.attr_name;
              prop.type = prop.prop_type;
              prop.icon = state.iconMap[prop.attr_name] || "icon-custom";
              prop.dimensionId = [prop.dimension_sub, prop.value, prop.id].join(
                ","
              ); // 增加属性细分唯一字段，区分同名自定义属性
              prop.isEventProp = true;
              prop.realTime = true;
              prop.custom = true;
              eventAttrMap[event.event_id].push(prop);
            });
            // delete event.event_attrs;
            if (!idMap[event.event_id]) eventList.push(event);
            idMap[event.event_id] = event;
            nameMap[event.event_name] = event;
          });
        });
        // 多主体，如果存在urlAppId，说明在看板或常用场景内部使用的，此时会更新sessionStorage缓存数，不更新state数据，不影响全局
        if (sessionStorage.getItem("urlAppId")) {
          sessionStorage.setItem("eventGroupsTemp", JSON.stringify(groups));
          sessionStorage.setItem("eventListTemp", JSON.stringify(eventList));
          sessionStorage.setItem("eventIdMapTemp", JSON.stringify(idMap));
          sessionStorage.setItem("eventAttrMapTemp", JSON.stringify(eventAttrMap));
        } else {
          window.eventAttrMap = eventAttrMap;
          state.eventIdMap = idMap;
          state.eventNameMap = nameMap;
          state.groupIdMap = groupIdMap;
          state.eventList = eventList;
          state.eventGroups = groups;
          eventIdAndGroupIdMap = initEventIdAndGroupIdMap;
        }
      },
      [mutations.biz.sys.setEnvMetas](state, list) {
        // todo 对列表进行标准化处理，同用户属性、事件属性等一同标准化，后期可在服务器端统一标准化
        list.forEach(prop => {
          prop.label = prop.text;
          prop.value = prop.name;
          prop.icon = state.iconMap[prop.name] || "icon-custom";
          prop.dimensionId = [prop.dimension_sub, prop.value].join(","); // 增加属性细分唯一字段，区分同名自定义属性
          prop.isEnvProp = true;
          prop.realTime = true;
          prop.custom = false;
        });
        if (sessionStorage.getItem("urlAppId")) {
           sessionStorage.setItem("eventEnvsTemp", JSON.stringify(list));
        }else{
          state.eventEnvs = list;
        } 
      },
      [mutations.biz.sys.delEvent](state, eventId) {
        if (!state.eventIdMap[eventId]) return;
        state.eventIdMap[eventId].is_delete = 1;
      },
      [mutations.biz.sys.setCurrentApp](state, app) {
        state.currentApp = app;
      },
      [mutations.biz.sys.editEvent](state, data) {
        const event = state.eventIdMap[data.event_id];
        for (const prop in data) {
          if (event[prop] !== undefined) {
            event[prop] = data[prop];
          }
        }
        state.eventGroups.forEach(eventGroup => {
          const index = eventGroup.eventList.findIndex(eventItem => {
            return eventItem.event_id === data.event_id;
          });
          if (index !== -1) {
            eventGroup.eventList.splice(index, 1, event);
          }
        });
      },
      [mutations.biz.sys.switchGroup](
        state,
        params = {
          appId: 0,
          platform: 0,
          oldEventGroupId: 0,
          eventGroupId: 0,
          eventIds: "0,1"
        }
      ) {
        const preGroup = params.oldEventGroupId
          ? state.groupIdMap[String(params.oldEventGroupId)]
          : null;
        const ids = params.eventIds.split(",").map(id => Number(id));
        if (preGroup) {
          ids.forEach(id => {
            preGroup.eventList.forEach((event, i) => {
              if (id === event.event_id) {
                preGroup.eventList.splice(i, 1);
              }
            });
            delete eventIdAndGroupIdMap[params.oldEventGroupId][id];
          });
        }
        if (params.eventGroupId) {
          ids.forEach(id => {
            const index = state.groupIdMap[
              params.eventGroupId
            ].eventList.findIndex(event => {
              return event.event_id === id;
            });
            if (index === -1) {
              state.groupIdMap[params.eventGroupId].eventList.push(
                state.eventIdMap[id]
              );
              eventIdAndGroupIdMap[params.eventGroupId][id] = true;
            }
          });
        }
        if (!params.oldEventGroupId && !params.eventGroupId) {
          ids.forEach(id => {
            for (const key in state.groupIdMap) {
              state.groupIdMap[key].eventList.forEach((event, i) => {
                if (id === event.event_id) {
                  state.groupIdMap[key].eventList.splice(i, 1);
                }
              });
              delete eventIdAndGroupIdMap[key][id];
            }
          });
        }
        if (eventIdAndGroupIdMap) {
          ids.forEach(id => {
            for (const groupId in eventIdAndGroupIdMap) {
              if (eventIdAndGroupIdMap[groupId].hasOwnProperty(id)) return;
            }
            eventIdAndGroupIdMap[-1][id] = true;
            state.groupIdMap[-1].eventList.push(state.eventIdMap[id]);
          });
        }
      },
      [mutations.biz.sys.updateGroup](state, group) {
        state.groupIdMap[group.eventGroupId].groupName = group.eventGroupName;
      },
      [mutations.biz.sys.addGroup](state, group) {
        eventIdAndGroupIdMap[group.groupId] = {};
        state.eventGroups.unshift(group);
        state.groupIdMap[group.groupId] = group;
      },
      [mutations.biz.sys.delGroup](state, id) {
        delete eventIdAndGroupIdMap[id];
        state.groupIdMap[id].eventList.forEach(event => {
          for (const groupId in eventIdAndGroupIdMap) {
            if (eventIdAndGroupIdMap[groupId].hasOwnProperty(event.event_id))
              return;
          }
          eventIdAndGroupIdMap[-1][id] = true;
          state.groupIdMap[-1].eventList.push(event);
        });
        delete state.groupIdMap[id];
        state.eventGroups.forEach((group, i) => {
          if (group.groupId === id) {
            state.eventGroups.splice(i, 1);
          }
        });
      }
    },
    actions: {
      [actions.biz.sys.queryEventAttrs](
        context,
        params = {
          eventId: 0,
        }
      ){
        return new Promise((resolve, reject) => { 
           ajax({
            url: apis.sys.queryEventAttrMetas,
            responseOnce: true,
            useTransform: false,
            data: {
              appId: util.getParamByUrl('appId') || context.rootState.bizSys.currentApp.id || 84,
              eventId: params.eventId
            }
          })
            .then(res => {
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      /**
       * 用户属性列表查询
       * @param context
       * @param params
       * @returns {Promise<any>}
       */
      [actions.biz.sys.queryUserProps](
        context,
        params = {
          appId: 0,
          platform: 0,
          force: false // 强制更新查询
        }
      ) {
        return new Promise((resolve, reject) => {
          if (context.state.ready.userProps && !params.force) {
            resolve();
            return;
          }
          store.setReady(context, "userProps", false);
          store.setError(context, "userProps", false);
          ajax({
            url: apis.sys.queryUserProps,
            toProxy: true,
            responseOnce: true,
            useTransform: false,
            data: {
              appId: params.appId,
              platform: params.platform
            }
          })
            .then(res => {
              context.commit(mutations.biz.sys.setUserProps, res.data);
              store.setReady(context, "userProps", true);
              resolve();
            })
            .catch(err => {
              store.setError(context, "userProps", true);
              reject(err);
            });
        });
      },
      /**
       * 事件列表查询，全量数据（包括被删除的事件）
       * @param context
       * @param params
       * @returns {Promise<any>}
       */
      [actions.biz.sys.queryEventMeta](
        context,
        params = {
          appId: 0,
          platform: 0,
          force: false
        }
      ) {
        return new Promise((resolve, reject) => {
          if (context.state.ready.eventGroups && !params.force) {
            resolve();
            return;
          }
          store.setReady(context, "eventGroups", false);
          store.setError(context, "eventGroups", false);
          ajax({
            url: apis.sys.queryEventGroup,
            toProxy: true,
            responseOnce: true,
            useTransform: false,
            data: {
              appId: params.appId,
              platform: params.platform,
              isAll: false
            }
          })
            .then(res => {
              context.commit(mutations.biz.sys.setEventGroups, res.data);
              store.setReady(context, "eventGroups", true);
              resolve();
            })
            .catch(err => {
              if (err.__CANCEL__) return;
              store.setError(context, "eventGroups", true);
              reject(err);
            });
        });
      },
      /**
       * 事件触发环境数据查询
       * @param context
       * @param params
       * @returns {Promise<any>}
       */
      [actions.biz.sys.queryEnvMeta](
        context,
        params = {
          appId: 0,
          platform: 0,
          force: false
        }
      ) {
        return new Promise((resolve, reject) => {
          if (context.state.ready.eventEnvs && !params.force) {
            resolve();
            return;
          }
          store.setReady(context, "eventEnvs", false);
          store.setError(context, "eventEnvs", false);
          ajax({
            url: apis.sys.queryEventEnv,
            // toProxy: true,
            // responseOnce: true,
            useTransform: false,
            data: {
              appId: params.appId,
              platform: params.platform
            }
          })
            .then(res => {
              context.commit(mutations.biz.sys.setEnvMetas, res.data.eventEnv);
              store.setReady(context, "eventEnvs", true);
              resolve();
            })
            .catch(err => {
              store.setError(context, "eventEnvs", true);
              reject(err);
            });
        });
      },
      [actions.biz.sys.setCurrentApp](context, app) {
        context.commit(mutations.biz.sys.setCurrentApp, app);
      },
      [actions.biz.sys.getCurrentUser](context) {
        store.setReady(context, "currentUser", false);
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.sys.getCurrentUser,
            method: "get"
          })
            .then(res => {
              context.commit(mutations.biz.sys.setCurrentUser, res.data.user);
              store.setReady(context, "currentUser", true);
              resolve(res);
            })
            .catch(reject);
        });
      },
      [actions.biz.sys.delEvent](
        context,
        param = {
          app_id: 0,
          event_id: 0
        }
      ) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.sys.delEvent,
            method: "post",
            data: param
          })
            .then(res => {
              if (res.flag !== 101) {
                reject(new Error("删除事件失败"));
                return;
              }
              context.commit(mutations.biz.sys.delEvent, param.event_id);
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      [actions.biz.sys.editEvent](context, data) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.sys.editEvent,
            method: "post",
            data: data
          })
            .then(res => {
              if (res.flag !== 101) {
                reject(new Error("修改事件失败"));
                return;
              }
              if (data.hasOwnProperty("hidden")) {
                data.event_hidden = data.hidden;
                delete data.hidden;
              }
              context.commit(mutations.biz.sys.editEvent, data);
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      [actions.biz.sys.editEventProp](context, params) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.sys.editEventProp,
            data: params
          })
            .then(res => {
              if (res.flag !== 101) {
                reject(new Error("事件属性修改失败"));
                return;
              }
              if (params.hasOwnProperty("type")) {
                params.prop_type = params.type;
                delete params.type;
              }
              const props = window.eventAttrMap[params.event_id];
              if (props) {
                props.forEach(prop => {
                  if (prop.attr_id === params.attr_id) {
                    for (const p in params) {
                      prop[p] = params[p];
                    }
                  }
                });
              }
              resolve(res);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      [actions.biz.sys.switchGroup](context, params) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.sys.switchGroup,
            type: "post",
            data: params
          })
            .then(res => {
              if (res.status === 200) {
                context.commit(mutations.biz.sys.switchGroup, params);
              }
              resolve(res);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      [actions.biz.sys.upsertGroup](context, param) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.sys.upsertGroup,
            type: "post",
            data: param
          })
            .then(res => {
              if (res.status !== 200) {
                reject(new Error(res.msg || "添加/修改事件组失败"));
                return;
              }
              if (param.eventGroupId) {
                // 编辑分组
                context.commit(mutations.biz.sys.updateGroup, param);
              } else {
                // 创建分组
                context.commit(mutations.biz.sys.addGroup, {
                  groupId: res.data.eventGroup.id,
                  groupName: param.eventGroupName,
                  eventList: []
                });
              }
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      [actions.biz.sys.delGroup](context, param) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.sys.deleteGroup,
            type: "post",
            data: param
          })
            .then(res => {
              if (res.status !== 200) {
                reject(new Error("删除事件分组失败"));
                return;
              }
              context.commit(mutations.biz.sys.delGroup, param.eventGroupId);
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        });
      }
    }
  });
  return store;
}
